import type { LucideIcon } from 'lucide-react';

type EmptyStateProps = {
  icon?: LucideIcon;
  message: string;
  subMessage?: string;
};

export function EmptyState({ icon: Icon, message, subMessage }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      {Icon && <Icon className="w-12 h-12 text-muted-foreground mb-4" />}
      <p className="text-muted-foreground text-center">{message}</p>
      {subMessage && <p className="text-muted-foreground text-center text-sm mt-2">{subMessage}</p>}
    </div>
  );
}
